let oemConfigMap = new Map();

//简化培训平台（去除了商城）
import configXinYuan from '@/config/oem/config_xinyuan.js'
oemConfigMap.set('edu.sdxyaqkj.com', configXinYuan)

import configAnBiao from '@/config/oem/config_anbiao.js'
oemConfigMap.set('edu.abaqsk.com', configAnBiao)

oemConfigMap.set('www.abaqsk.com', configAnBiao)
export default oemConfigMap;



// WEBPACK FOOTER //
// ./src/config/oem_config_map.js